<template>
  <div class="auth-container">
   <main>
     <section>
       <router-view></router-view>
     </section>
   </main>
 </div>
</template>
<script>
// import NotificationBanner from '../SystemNotifications/NotificationBanner.vue';
// import { getActiveBanner } from '../../apis/systemNotifications';

export default {
  data() {
    return {
      banners: [],
      showDialog: false,
    };
  },
  components: {
    // NotificationBanner,
  },
  methods: {
  },
  async created() {
    // this.banners = await getActiveBanner();
    this.showDialog = process.env.VUE_APP_SHOW_CHINA_LOGIN;
  },
};
</script>
<style scoped>
.auth-container {
 position: relative;
 /* padding-bottom: 58px; */
 min-height: 100vh;
 margin-left: 0px;
 margin-right: 0px;
 overflow-x: hidden;
}
</style>
